import MuiMenuItem from '@mui/material/MenuItem';
import { alpha, styled } from '@mui/material/styles';

export const StyledMenuItem = styled(MuiMenuItem)(({ theme }) => ({
  '&:focus-visible': {
    outline: `3px solid ${alpha(theme.palette.primary.main, 0.28)}`,
    outlineOffset: -3,
  },
})) as typeof MuiMenuItem;
